import { MortgageCampaignSaroutycreditsimulatorTemplate } from 'common/module/mortgage/campaign/saroutycreditsimulator/template';
import { MortgageCampaignSaroutycreditsimulatorView } from 'common/module/mortgage/campaign/saroutycreditsimulator/view';
import { MortgageCampaignSaroutycreditsimulatorViewStoreFactory } from 'common/module/mortgage/campaign/saroutycreditsimulator/view-store.factory';
import { PreactView } from 'common/module/preact/view';

/**
 * Do not remove 'default' as it is needed for loading asynchronously webpack chunks
 */
export default function MortgageCampaignSaroutycreditsimulatorViewFactory(): MortgageCampaignSaroutycreditsimulatorView {
  return new MortgageCampaignSaroutycreditsimulatorView(
    new PreactView(
      MortgageCampaignSaroutycreditsimulatorTemplate,
      MortgageCampaignSaroutycreditsimulatorViewStoreFactory()
    )
  );
}
